<template>
  <div class="chart-container">
    <apexchart 
      type="line"
      :height="chartHeight"
      :options="apexOptions"
      :series="apexSeries"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ClientTeusLineChart',
  
  components: {
    apexchart: VueApexCharts
  },
  
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartHeight: {
      type: Number,
      default: 300
    }
  },

  computed: {
    apexSeries() {
      if (!this.chartData || !this.chartData.datasets) {
        return []
      }
      
      return this.chartData.datasets.map(dataset => ({
        name: dataset.label || 'TEUs',
        data: dataset.data || []
      }))
    },
    
    apexOptions() {
      return {
        chart: {
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        xaxis: {
          categories: this.chartData.labels || [],
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          title: {
            text: 'TEUs'
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (val) {
              return val + ' TEUs'
            }
          }
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
        markers: {
          size: 4,
          hover: {
            size: 6
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
}
</style>




// WEBPACK FOOTER //
// ClientTeusLineChart.vue?fc854818